import { Form, Formik, FormikErrors, FormikProps } from 'formik';

import { IRIFormProps } from '../../../_core/form/form.types';
import { IRequestAccessFormParams } from '../message.types';
import { FormInputWithLabel } from '../../../_core/form/input/form-labelled-input.component';
import { isValidEmail } from '../../../../utils/validation.helpers';
import { FormActionsRow } from '../../../_core/form/input/form-actions-row';
import { FormButton } from '../../../_core/form/button/form-button.component';

export const RequestAccessForm = ({ onSubmit, onBack }: IRIFormProps<IRequestAccessFormParams>) => {
  const validateForm = (values: IRequestAccessFormParams) => {
    const errors: FormikErrors<IRequestAccessFormParams> = {};
    if (!values.name) errors.name = 'Required';
    if (!isValidEmail(values.email)) errors.email = 'Must include a valid email';
    return errors;
  };

  return (
    <Formik initialValues={{ name: '', email: '' }} onSubmit={onSubmit} validate={validateForm} validateOnBlur={false}>
      {(props: FormikProps<IRequestAccessFormParams>) => (
        <Form action="#" method="POST" className="sm:max-w-xl mx-auto space-y-4 mt-10">
          <FormInputWithLabel autoFocus name="name" label="Name" placeholder="Name" />
          <FormInputWithLabel name="email" label="Email" placeholder="Email" type="email" />
          <FormActionsRow>
            {!!onBack && <FormButton onPress={onBack} text="Cancel" type="button" variant="secondary" />}
            <FormButton loading={props.isSubmitting} text="Submit" />
          </FormActionsRow>
        </Form>
      )}
    </Formik>
  );
};
